// Module
var code = "<md-bottom-sheet> <md-content> <md-list> <md-list-item ng-repeat=\"article in $ctrl.articles\" ng-click=\"$ctrl.showArticle(article)\"> {{ article.title }} <md-divider></md-divider> </md-list-item> </md-list> </md-content> </md-bottom-sheet> ";
// Exports
module.exports = code;